<template>
  <link href="https://cdn.jsdelivr.net/npm/@mdi/font@5.x/css/materialdesignicons.min.css" rel="stylesheet">
  <v-layout class="rounded rounded-md">
    <v-app-bar app dense class="d-flex justify-between">

      <v-container class="flex-fill text-left d-flex align-left justify-start">
      </v-container>

      <v-container class="flex-fill text-center d-flex align-center justify-center">
      </v-container>

      <v-container class="flex-fill text-center d-flex align-center justify-end">

        <v-menu v-if="loggedIn">
          <template v-slot:activator="{ props }">
            <v-btn color="transparent" v-bind="props" class="no-uppercase text-body-2 text-black">
              <span class="ma-2 text-grey-darken-3 text-caption" v-if="loggedIn">{{ email }}</span>
              <ProfileCircle :name="username" v-if="loggedIn" />
            </v-btn>
          </template>
          <v-list class="ma-0 pa-0">
            <v-list-item class="ma-0 pa-0">
              <v-btn class="w-100" prepend-icon="mdi-logout" size="small" levation="4" @click="logout">
                Logout
              </v-btn>
            </v-list-item>
          </v-list>
        </v-menu>

      </v-container>
    </v-app-bar>
    <v-snackbar v-model="showSnackbar" timeout="5000" color="error" top>
      ⚠️ Nicht genügend Rechte im aktuellen Profil freigeschaltet!
      <template #action>
        <v-btn text @click="closeSnackbar">Schließen</v-btn>
      </template>
    </v-snackbar>
    <v-main :class="isMobile ? 'd-flex align-center justify-center' : 'd-flex align-center justify-center'"
      :style="{ width: isMobile ? '100%' : '100%' }">
      <router-view v-slot="{ Component }" @login-success="handleSuccessfulLogin">
        <transition name="fade" mode="out-in">
          <component :is="Component" :isMobile="isMobile" />
        </transition>
      </router-view>
    </v-main>
  </v-layout>
</template>

<script>
import ProfileCircle from "./components/ProfileCircle.vue";
import axios from 'axios';
import config from './config.js';
import { useRouter } from "vue-router";

export default {
  components: {
    ProfileCircle,
  },
  data() {
    return {
      drawer: true,
      isMobile: false,
      loggedIn: localStorage.getItem('token'),
      username: '',
      email: '',
      showSnackbar: false,
    };
  },
  mounted() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
    this.getUser();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    async getUser() {
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('Token not found in localStorage');
      }
      const headers = {
        Authorization: `Token ${token}`
      }

      const response = await axios.get(`${config.baseURL}/api/v1/user/me/`, { headers }).catch(e => {
        this.$router.push('/login');
      })
      if (response.status == 200) {
        const user_json = response.data
        this.username = user_json.first_name + ' ' + user_json.last_name
        this.email = user_json.email
      }
    },
    async logout() {
      this.$router.push('/logout');
      this.loggedIn = false;
    },
    handleSuccessfulLogin() {
      this.loggedIn = true;
      this.getUser();
    },
    handleResize() {
      this.isMobile = (window.innerWidth < 765);
      console.log(this.isMobile)
      this.drawer = !this.isMobile;
    },
    openComponentHome() {
      this.$router.push('/');
    },
    openComponentDigitalAssistant() {
      this.$router.push('/chatbot');
    },
    openComponentBiDashboard() {
      this.$router.push('/bi-dashboard');
    },
    openComponentAiDashboard() {
      this.$router.push('/ai-dashboard');
    },
    openComponentSharepoint() {
      // this.activeWindow = 'sharepoint';
      this.$router.push('/sharepoint');
    },
    openComponentDigitalTriplet() {
      this.$router.push('/digitaltriplet');
    },
    openComponentMarketAnalyzer() {
      this.$router.push('/marketanalyzer');
    },
    openComponentMarketAnalyzer() {
      this.$router.push('/marketanalyzer');
    },
    openComponentChatbot() {
      this.$router.push('/chatbot');
    }
  },
};
</script>

<style scoped>
.no-uppercase {
     text-transform: unset !important;
}

.logo {
  height: 6em;
  padding: 1.5em;
  will-change: filter;
  transition: filter 300ms;
  background-color: white;
}

.logo:hover {
  filter: drop-shadow(0 0 2em #646cffaa);
}

.logo.vue:hover {
  filter: drop-shadow(0 0 2em #002394aa);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
